<template lang="html">

  <section class="game type-wordsearch">
    
    <GameMenu />

    <div class="container">

      <Grid 
        type="wordsearch"
      />

      <Wordlist />

    </div>

    <!-- <Adsense
      data-ad-client="ca-pub-4799626540510986"
      data-ad-slot="4304747998"
      data-ad-format="auto"
      data-full-width-responsive="true" 
      data-ad-test="on" 
    /> -->

    <transition name="delay">
      <CompletedModal 
        v-show="completed && !manuallyClosedModal"
        @CloseCompletedModal="closeCompModal"
      />
    </transition>

  </section>

</template>

<script lang="js">

  import { mapActions, mapState } from 'vuex'

  import Grid from '@puzzleapps/wordsearch/src/components/Grid'
  import Wordlist from '@puzzleapps/wordsearch/src/components/Wordlist'
  import GameMenu from '@puzzleapps/shared/src/components/ui/GameMenu'
  import CompletedModal from '@puzzleapps/shared/src/components/ui/CompletedModal2'
  // import CurrentClue from '@/components/wordsearch/CurrentClue'
  
  export default  {
    name: 'game',
    props: [],
    components: {
      Grid,
      Wordlist,
      CompletedModal,
      GameMenu,
    },

    data() {
      return {
        manuallyClosedModal: false,
      }
    },

    mounted() {
      this.selectThemeFromLocal()
    },

    destroyed() {
      this.setIsPlaying(false)
    },

    methods: {
      ...mapActions({
        setIsPlaying: 'game/setIsPlaying',
        selectThemeFromLocal: 'userSettings/selectThemeFromLocal',
        getBestTime: 'game/getPuzzleBestTime',
      }),

      closeCompModal()
      {
          this.manuallyClosedModal = true;
      },
    },

    computed: {
      ...mapState({
        puzzleId: state => state.game.puzzleId,
        completed: state => state.game.completed,
        bestTime: state => state.game.puzzleBestTime,
      })
    }
  }


</script>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/variables';
  
  .delay-enter-active {
    transition: all 3s cubic-bezier(1,.01,1,-0.12);
  }
  .delay-leave-active {
    transition: all 0s;
  }
  .delay-enter, .delay-leave-to, .delay-leave-active {
    opacity: 0;
  }

  .adswrapper {
    min-width: 250px;
  }
  
  // TODO dont copy this css and use an un-scoped version instead
  .game {
    width: 100%;
    height: 100%;
    // max-width: 1200px;
    margin: auto;
    // border: 1px solid #ebebeb;

    @media (max-width: 868px) {
      border: 0;
    }

    .container {
      display: flex;
      padding: 1rem;      
      justify-content: center;
      // height: calc(100% - 80px);      
      flex-wrap: wrap;
      flex-direction: row;
      margin: auto;

      // unique
      max-width: 1024px;
      //////
      
      @media (max-width: 868px) {
        height: calc(100% - 78px);
        flex-direction: column;
      }

      .grid {
        box-sizing: border-box;    
        flex: 2;
        padding: 0;
        @media (max-width: 868px) {
          flex: 0;
          touch-action: none;
        }
      }

    }
  }



</style>
